module.exports = __webpack_public_path__ + "img/inbox.d0f39f99.svg";